// extracted by mini-css-extract-plugin
module.exports = {"card":"EmployeeCard_card__gVuMP"};